import { TenantBadge } from '@/modules/administration/components/TenantBadge';
import type { CompanyApi } from '@/modules/companies/types';
import { Button } from '@/modules/ui/components/button/Button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/modules/ui/components/dialog/Dialog';
import type { UserApi } from '@/modules/users/types';

interface ManageTenantsDialogProps {
  user: UserApi | null;
  onClose: () => void;
  companies: CompanyApi[] | undefined;
  onSetDefault: (userId: string, tenantId: string) => void;
  onRemove: (userId: string, tenantId: string) => void;
}

export const ManageTenantsDialog = ({
  user,
  onClose,
  companies,
  onSetDefault,
  onRemove,
}: ManageTenantsDialogProps) => {
  return (
    <Dialog open={!!user} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>
            Manage Tenants for {user?.firstName} {user?.lastName}
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-wrap gap-2 py-4">
          {user?.tenantIds
            ?.slice()
            .sort((a, b) => {
              if (a === user.defaultTenantId) return -1;
              if (b === user.defaultTenantId) return 1;
              return 0;
            })
            .map((tenantId) => {
              const company = companies?.find((c) => c.id === tenantId);
              const isDefault = user.defaultTenantId === tenantId;

              return (
                <TenantBadge
                  key={tenantId}
                  tenantId={tenantId}
                  user={user}
                  companyName={company?.name || 'Unknown Tenant'}
                  isDefault={isDefault}
                  onSetDefault={onSetDefault}
                  onRemove={onRemove}
                />
              );
            })}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
